import { useNavigate } from "react-router-dom";
import { cn } from "@/lib/utils";

interface LogoProps {
  to?: string;
  className?: string;
  showText?: boolean;
  disabled?: boolean;
}

// Ping Ripple Logo SVG
const PingRippleLogo = ({ className = "" }: { className?: string }) => (
  <svg 
    viewBox="0 0 40 40" 
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Outer ping wave */}
    <circle 
      cx="20" 
      cy="20" 
      r="16" 
      fill="none" 
      stroke="currentColor" 
      strokeWidth="1.5" 
      opacity="0.3"
      className="animate-ping"
    />
    {/* Middle ping wave */}
    <circle 
      cx="20" 
      cy="20" 
      r="12" 
      fill="none" 
      stroke="currentColor" 
      strokeWidth="2" 
      opacity="0.5"
    />
    {/* Inner ping wave */}
    <circle 
      cx="20" 
      cy="20" 
      r="8" 
      fill="none" 
      stroke="currentColor" 
      strokeWidth="2.5" 
      opacity="0.8"
    />
    {/* Central coin/dollar symbol */}
    <circle 
      cx="20" 
      cy="20" 
      r="6" 
      fill="currentColor"
    />
    <text 
      x="20" 
      y="26" 
      fontSize="12" 
      fontWeight="bold" 
      textAnchor="middle" 
      fill="hsl(var(--primary-foreground))"
    >
      $
    </text>
  </svg>
);

export function Logo({ to = "/", className, showText = true, disabled = false }: LogoProps) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (!disabled && to) {
      navigate(to);
    }
  };

  return (
    <div
      onClick={handleClick}
      className={cn(
        "inline-flex items-center gap-3 transition-smooth group",
        !disabled && to && "cursor-pointer",
        disabled && "cursor-default",
        className
      )}
    >
      <div className="relative flex items-center justify-center w-12 h-12 rounded-2xl gradient-primary shadow-glow group-hover:shadow-elevated transition-all group-hover:scale-110">
        <PingRippleLogo className="h-10 w-10 text-primary-foreground" />
        <div className="absolute -top-1 -right-1 w-2.5 h-2.5 bg-secondary rounded-full opacity-90" />
      </div>
      {showText && (
        <span className="text-2xl font-bold text-foreground group-hover:tracking-wide transition-all">
          PingEarn
        </span>
      )}
    </div>
  );
}
